// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__Aij7F","cashedOut":"styles_cashedOut__0i-Jt","cancelBet":"styles_cancelBet__AYBi8"};